import 'isomorphic-fetch';
import {config} from 'config'

export const api = {
    proveedores:{
		async create(data) {
            const response = await fetch(config.URL_API + '/proveedores/alta', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            },
		    body: JSON.stringify(data)
        });
            const responseData = await response.json();
            return responseData;
        },
        async estado(data){
            const response = await fetch(config.URL_API + `/proveedores/estado`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data)
    	});
            const responseData = await response.json();
            return responseData;
        },
		async getAll(params = ''){
			const response = await fetch(config.URL_API + '/proveedores&'+params, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
		},
		async baja(data){
            const response = await fetch(config.URL_API + `/proveedores/baja`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data)
    	});
            const responseData = await response.json();
            return responseData;
        },
		async update(data){
            const response = await fetch(config.URL_API + '/proveedores/modificar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data)
    	});
            const responseData = await response.json();
            return responseData;
        },
    },
    localidades:{
		async getAll(params = ''){
			const response = await fetch(config.URL_API + '/localidades&'+params, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
        },
        async get(id){
			const response = await fetch(config.URL_API + '/localidades/'+id, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
		},
    },
    iva:{
		async getAll(params = ''){
			const response = await fetch(config.URL_API + '/condicionesiva&'+params, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
		},
    },
    tipodoc:{
		async getAll(params = ''){
			const response = await fetch(config.URL_API + '/documentos&'+params, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
		},
    },
    estadocta: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/cuentas_proveedores/saldos&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async PDF(params = '') {
			const res = await fetch(config.URL_API + '/cuentas_proveedores/pdfSaldos&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], 'Proveedor-Saldos.pdf', { type: 'application/pdf' })
			return file;
        },
	},
};
